import { LearningObject } from "@app/common/models/learning-object";

export class Tag extends LearningObject{
    name: string;
    selected: boolean;
  }